export default {
  name: 'view-info',
  components: {},
  props: [],
  data () {
    return {
      loading: false
    }
  },
  computed: {
    checklist_users () {
      return this.$store.getters['Audit/getUserOfChecklist']
    }
  },
  mounted () {

  },
  methods: {
    show (checklist) {
      this.loading = true
      this.$refs.viewInfo.show()
      Promise.all([
        this.$store.dispatch('Audit/getUserOfChecklist', {checklist})
      ]).then(res => {
        this.loading = false
        this.$refs.viewInfo.show()
        this.$loading.complete()
      }).catch(errors => {
        this.loading = false
        this.$loading.fail()
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/checklist/list/view-info/view-info.js